module.exports = __webpack_public_path__ + "media/packs/images/flags/PK-3edae268c3755b1fc75a714c30bc37fb.png";